export function mapNullValuesToEmptyString(val) {
  const mappedEntry = {};
  for (const [key, value] of Object.entries(val)) {
      mappedEntry[key] = value ?? undefined;
  }
  return mappedEntry;
}